<template>
  <div id="content" class="manage_default_data">

      <div class="content_div stats" v-if="data">
        <h1>{{data.dataname}}</h1>
        <div class="mt20" >
          <textarea v-if="data.datatype == 'textarea'" class="innopearl_input" name="name" rows="8" cols="80" v-model="data.datavalue"></textarea>

          <QuillEditor ref="dataContent" v-show="data.datatype == 'richData'"  theme="snow" v-model="data.datavalue" :content="data.datavalue" contentType="delta" :toolbar="toolbarOptions" />

        </div>

        <button type="button" class="next_step_btn" @click="save" name="button">{{$t("Save data")}}</button>
      </div>
  </div>
</template>
<script>
import api from '../tools/api';
// import router from '@/router'
import { QuillEditor } from '@vueup/vue-quill'

import '@vueup/vue-quill/dist/vue-quill.snow.css';


 import { toast } from 'vue-sonner'
export default {
  components: {
    QuillEditor
  },
  name: 'Manage_Default_Data',
  data() {
    return {
      pageInfo: {
        mainTitle : "Manage default data",
        subTitle : "",
      },
      data: null,
      toolbarOptions : [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons             // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent                  // text direction
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        ['clean']                                         // remove formatting button
      ],
    }
  },
  methods:{
    save(){
      if(this.data.datatype == "richData"){
        this.data.datavalue = this.$refs.dataContent.getHTML();
      }

      api.post(process.env.VUE_APP_API_URL+"/restrict/set_innodata",
        {
          data :this.data,
        },
        { headers: {'Content-Type': 'application/json',}}
      ).then( () => {
        this.$nextTick(() => {
          this.$refs.dataContent.setHTML(this.data.datavalue);
        });
        toast.success("Data successfully updated");
        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    }

  },
  mounted(){

     api.get(process.env.VUE_APP_API_URL+"/restrict/get_innodata/"+this.$route.params.dataid).then( (r) => {
       console.log(r.data);
       this.data = r.data;
       this.pageInfo.subTitle = this.data.dataname;
            this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
       if(this.data.datatype == "richData"){
         this.$nextTick(() => {
           this.$refs.dataContent.setHTML(this.data.datavalue);
         });
       }

     }).catch( (e) => {
       console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
   });
  },


}
</script>
<style scoped>

.manage_default_data{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}


.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
  display:inline-block;
}

.mt20{
  margin-top:20px;
  margin-bottom: 20px;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
box-sizing: border-box;
margin-top:10px;
margin-bottom: 20px;
padding: 5px;
}


</style>
<style media="screen">
  .manage_default_data .ql-editor{
    min-height:200px;
    font-family: 'Montserrat' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value]::before {
    content: attr(data-value) !important;
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Roboto"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Roboto"]::before {
    font-family: 'Roboto' !important;
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="OpenSans"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="OpenSans"]::before {
    font-family: 'Open Sans' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Lato"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Lato"]::before {
    font-family: 'Lato' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Montserrat"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Montserrat"]::before {
    font-family: 'Montserrat' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SourceSansPro"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SourceSansPro"]::before {
    font-family: 'Source Code Pro' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Poppins"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Poppins"]::before {
    font-family: 'Poppins' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Raleway"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Raleway"]::before {
    font-family: 'Raleway' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Ubuntu"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Ubuntu"]::before {
    font-family: 'Ubuntu' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Oswald"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Oswald"]::before {
    font-family: 'Oswald' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Merriweather"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Merriweather"]::before {
    font-family: 'Merriweather' !important;
  }

  .ql-font-Oswald{
        font-family: 'Oswald' !important;
  }
  .ql-font-Merriweather{
        font-family: 'Merriweather' !important;
  }
  .ql-font-Ubuntu{
          font-family: 'Ubuntu' !important;
  }
  .ql-font-Raleway{
          font-family: 'Raleway' !important;
  }
  .ql-font-Poppins{
          font-family: 'Poppins' !important;
  }
  .ql-font-Montserrat{
          font-family: 'Montserrat' !important;
  }
  .ql-font-Lato{
          font-family: 'Lato' !important;
  }
  .ql-font-Oswald{
          font-family: 'Oswald' !important;
  }

  .ql-font-OpenSans{
          font-family: 'Open Sans' !important;
  }

  .ql-font-SourceSansPro{
      font-family: 'Source Code Pro' !important;
  }

  .ql-snow .ql-picker.ql-font {
    width: 150px !important;
    white-space: nowrap;
  }

  .ql-container{
    font-size:14px !important;
  }
</style>
